<smrts-dialog title="Liberar troca de senha" [hasFootnote]="true">

  <div class="content">
    <div class="info-message accent-color">
      <mat-icon fontSet="material-icons-outlined" class="accent-color">info</mat-icon>
      <span>Defina a nova senha de <strong>{{ usuario.login }}</strong> e informe-a ao usuário.</span>
    </div>

    <p-floatlabel variant="on">
      <input pInputText id="novaSenha" type="password" [(ngModel)]="novaSenha" style="width: 100%;" />
      <label for="novaSenha">Nova senha</label>
    </p-floatlabel>

    <div>
      <p-floatlabel variant="on">
        <input pInputText id="confirmacaoNovaSenha" type="password" [(ngModel)]="confirmacaoNovaSenha" style="width: 100%;" />
        <label for="confirmacaoNovaSenha">Confirmar nova senha</label>
      </p-floatlabel>
      @if (senhasNaoConferem) {
        <small class="field-error">As senhas não conferem</small>
      }
    </div>
  </div>

  <div footnote class="footnote">
    <button class="accent-text-button btn-cancelar" mat-button [mat-dialog-close]="null">
      Cancelar
    </button>
    <button class="white-text-button" mat-flat-button (click)="salvarClick()" [disabled]="salvando">
      Trocar senha
    </button>
  </div>

</smrts-dialog>
